import {
  Box,
  Button,
  FormControl,
  Grid,
  Snackbar,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Header from "../../components/Header";
import { useNavigate } from "react-router-dom";
import * as yup from "yup";
import { getAudio, getAllArtists, updateAudio } from "./../../ApiConfig.jsx";


const validationSchema = yup.object().shape({
  title: yup.string().required("Title is required"),
  type: yup.string().required("Type is required"),
  audio_type: yup.string().required("Audio type is required"),
  artist_name: yup.string(),
  amount: yup.string().when("type", {
    is: "Paid",
    then: yup
      .string()
      .required("Amount is required")
      .matches(/^\d+$/, "Amount must contain only numbers"),
    otherwise: yup.string(),
  }),
  language: yup.string().required("Language is required"),
  audio: yup.mixed(),
  image: yup.mixed(),
});

function EditAudio() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [status, setStatus] = useState("Inactive");

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [alertSeverity, setAlertSeverity] = useState("success");
  const [alertMessage, setAlertMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const initialUserDetails = {
    title: "",
    amount: "",
    type: "",
    audio_type: "",
    artist_name: "",
    language: "",
    audio: null,
    image: null,
  };

  const [userDetails, setUserDetails] = useState(initialUserDetails);
  const [errors, setErrors] = useState({});
  const [artists, setArtists] = useState([]);

  const fetchAudio = async (id) => {
    try {
      const data = await getAudio(id);
      if (data.status) {
        console.log(data.result);
        setStatus(data.result.status);
        setUserDetails({
          title: data.result.title,
          type: data.result.type,
          audio_type: data.result.audio_type,
          artist_name: data.result.artist_name,
          amount: data.result.amount ? data.result.amount : "",
          language: data.result.language,
          audio: null,
          image: null,
          currentImage: data.result.image_url,
          currentAudio: data.result.audio_url,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  useEffect(() => {
    fetchAudio(id);
  }, [id]);

  useEffect(() => {
    const getArtists = async () => {
      try {
        const artistData = await getAllArtists();
        if (artistData.status) {
          setArtists(artistData.result);
        }
      } catch (error) {
        console.log(error);
      }
    };
    getArtists();
  }, []);

  const handleFieldChange = (field, value) => {
    if (field == "type" && value == "Free") {
      setUserDetails((prevUserDetails) => ({
        ...prevUserDetails,
        amount: "0",
      }));
      setErrors((prevErrors) => {
        return { ...prevErrors, amount: "" };
      });
    }

       if (field == "type" && value == "Paid") {
         setUserDetails((prevUserDetails) => ({
           ...prevUserDetails,
           amount: "0",
         }));
      
       }

    if (field == "audio_type" && value == "Bible") {
      setUserDetails((prevUserDetails) => ({
        ...prevUserDetails,
        artist: "",
      }));
    }

    console.log(value);
    setUserDetails((prevUserDetails) => ({
      ...prevUserDetails,
      [field]: value,
    }));
    validateField(field, value);
  };

  const validateField = (field, value) => {
    validationSchema
      .validateAt(field, { ...userDetails, [field]: value })
      .then(() => {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: "" }));
      })
      .catch((error) => {
        setErrors((prevErrors) => ({ ...prevErrors, [field]: error.message }));
      });
  };

  const updateAudioHandler = async (userDetails) => {
    if (userDetails.audio_type == "Artist" && userDetails.artist_name == "") {
      console.log("xx");
      setErrors((prevUserDetails) => ({
        ...prevUserDetails,
        artist_name: "Artist can not be empty",
      }));
      return;
    }

    if (userDetails.audio && !userDetails.audio.type.startsWith("audio/")) {
      setErrors((prevUserDetails) => ({
        ...prevUserDetails,
        audio: "Audio must be a valid audio type",
      }));

      return;
    }

    if (userDetails.image && !userDetails.image.type.startsWith("image/")) {
      setErrors((prevUserDetails) => ({
        ...prevUserDetails,
        image: "Image must be a valid image type",
      }));

      return;
    }

    const hasErrors = Object.values(errors).some(
      (errorMessage) => errorMessage !== ""
    );

    if (hasErrors) {
      console.log("Errors found. Cannot update.");
      return;
    }

    console.log(userDetails);
    setIsLoading(true);
    const formData = new FormData();
    formData.append("title", userDetails.title);
    formData.append("type", userDetails.type);
    formData.append("audio_type", userDetails.audio_type);
    formData.append("artist_name", userDetails.artist_name);
    formData.append("amount", userDetails.amount ? userDetails.amount : "0");
    formData.append("language", userDetails.language);
    formData.append("audio", userDetails.audio);
    formData.append("image", userDetails.image);
    formData.append("status", status == "Active" ? "Active" : "Inactive");

    try {
      const audioData = await updateAudio(id, formData);
      console.log(audioData);

      if (audioData.status) {
        setAlertSeverity("success");
        setAlertMessage("Audio updated successfully");

        setTimeout(() => {
          navigate("/audio-management");
        }, 3000);
      }
    } catch (err) {
      console.log(err);
      setAlertSeverity("error");
      setAlertMessage(`Failed to update audio: ${err.message}`);
    } finally {
      setOpenSnackbar(true);
      setIsLoading(false);
    }
  };
  const AudioPlayer = React.memo(({ audioUrl }) => (
    <audio controls style={{ width: "100%" }}>
      <source src={audioUrl} type="audio/mp3" />
    </audio>
  ));
  return (
    <Box m="20px" height="70vh" overflow="auto" paddingRight="20px">
      <Header title={`Edit Audio ${id}`} subtitle="" />
      <Box ml={"40px"}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Title*
            </Typography>
            <TextField
              type="text"
              fullWidth
              variant="filled"
              value={userDetails.title}
              onChange={(e) => handleFieldChange("title", e.target.value)}
              error={!!errors.title}
              helperText={errors.title}
            />
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Type*
            </Typography>
            <FormControl fullWidth variant="filled">
              <Select
                value={userDetails.type}
                onChange={(e) => handleFieldChange("type", e.target.value)}
                name="type"
                error={!!errors.type}>
                <MenuItem value="Free">Free</MenuItem>
                <MenuItem value="Paid">Paid</MenuItem>
              </Select>
              {errors.type && (
                <Typography variant="caption" color="error">
                  {errors.type}
                </Typography>
              )}
            </FormControl>
          </Grid>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Audio type*
            </Typography>
            <FormControl fullWidth variant="filled">
              <Select
                value={userDetails.audio_type}
                onChange={(e) =>
                  handleFieldChange("audio_type", e.target.value)
                }
                name="audio_type"
                error={!!errors.audio_type}>
                <MenuItem value="Bible">Bible</MenuItem>
                <MenuItem value="Artist">Artist</MenuItem>
              </Select>
              {errors.type && (
                <Typography variant="caption" color="error">
                  {errors.type}
                </Typography>
              )}
            </FormControl>
          </Grid>
          {userDetails.type == "Paid" && (
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Amount*
              </Typography>
              <TextField
                type="text"
                fullWidth
                variant="filled"
                value={userDetails.amount}
                onChange={(e) => handleFieldChange("amount", e.target.value)}
                error={!!errors.amount}
                helperText={errors.amount}
              />
            </Grid>
          )}

          {userDetails.audio_type == "Artist" && (
            <Grid item xs={12} md={6}>
              <Typography variant="subtitle1" fontWeight="bold">
                Artist*
              </Typography>
              <FormControl fullWidth variant="filled">
                <Select
                  value={userDetails.artist_name}
                  onChange={(e) =>
                    handleFieldChange("artist_name", e.target.value)
                  }
                  name="artist_name"
                  error={!!errors.artist_name}>
                  {artists.map((artist, index) => {
                    return (
                      <MenuItem key={index} value={artist.artist_name}>
                        {artist.artist_name}
                      </MenuItem>
                    );
                  })}
                </Select>
                {errors.artist_name && (
                  <Typography variant="caption" color="error">
                    {errors.artist_name}
                  </Typography>
                )}
              </FormControl>
            </Grid>
          )}
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle1" fontWeight="bold">
              Language*
            </Typography>
            <FormControl fullWidth variant="filled">
              <Select
                value={userDetails.language}
                onChange={(e) => handleFieldChange("language", e.target.value)}
                name="language"
                error={!!errors.language}>
                <MenuItem value="English">English</MenuItem>
                <MenuItem value="French">French</MenuItem>
              </Select>
              {errors.language && (
                <Typography variant="caption" color="error">
                  {errors.language}
                </Typography>
              )}
            </FormControl>
          </Grid>

          <Grid item xs={12} md={6}>
            {" "}
            <Box>
              <div style={{ fontWeight: "bold" }}>Audio*</div>
              <TextField
                fullWidth
                variant="filled"
                type="file"
                accept="audio/*"
                onChange={(e) => handleFieldChange("audio", e.target.files[0])}
                name="image"
                error={!!errors.audio}
                helperText={errors.audio}
              />
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            {" "}
            <Box>
              <div style={{ fontWeight: "bold" }}>Image*</div>
              <TextField
                fullWidth
                variant="filled"
                type="file"
                accept="image/*"
                onChange={(e) => handleFieldChange("image", e.target.files[0])}
                name="image"
                error={!!errors.image}
                helperText={errors.image}
              />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            {" "}
            <Box>
              <div style={{ fontWeight: "bold" }}>Current Audio</div>
              <AudioPlayer audioUrl={userDetails.currentAudio} />
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            {" "}
            <Box>
              <div style={{ fontWeight: "bold" }}>Current Image</div>
              <img
                src={userDetails.currentImage}
                style={{ width: "100%" }}
                alt=""
              />
            </Box>
          </Grid>

          <Grid item xs={12}>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#6870fa",
                color: "white",
                fontSize: "16px",
                "&:hover": {
                  backgroundColor: "#3e4396",
                },
              }}
              onClick={() => updateAudioHandler(userDetails)}>
              {isLoading ? "Updating..." : "Update"}
            </Button>
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        open={openSnackbar}
        autoHideDuration={5000}
        onClose={() => setOpenSnackbar(false)}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}>
        <MuiAlert
          onClose={() => setOpenSnackbar(false)}
          severity={alertSeverity}
          elevation={6}
          variant="filled"
          style={{ color: "white" }}>
          {alertSeverity === "success" ? "Success" : "Error"}
          {": "}
          {alertMessage}
        </MuiAlert>
      </Snackbar>
    </Box>
  );
}

export default EditAudio;
